import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_MeldiDham/layout/core'
import MemberLiveReportList from '../../pages/member-report/MemberLiveReportList'
const MemberLiveReportMasterPage: React.FC = () => {
  return (
    <Switch>
      <Route path='/ram-nam-bank/member-live-report/list'>
        <PageTitle>Member Live Report List</PageTitle>
        <MemberLiveReportList />
      </Route>
      <Redirect
        from='/ram-nam-bank/member-live-report'
        exact={true}
        to='/ram-nam-bank/member-live-report/list'
      />
      <Redirect to='/ram-nam-bank/member-live-report/list' />
    </Switch>
  )
}

export default MemberLiveReportMasterPage
